import { AfterViewInit, Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';

/**
 * Directive to hide an step icon a twc-wizard component
 *
 * Use:
 * <twc-wizard-step cwHideStepIcon label="Title">Step content</twc-wizard-step>
 */
@Directive({
    selector: 'twc-wizard-step[cwHideStepIcon]',
    standalone: false,
})
export class WizardHideStepIconDirective implements AfterViewInit, OnDestroy {
    private styleEl: HTMLStyleElement | null = null;

    constructor(
        private el: ElementRef,
        private renderer: Renderer2
    ) {}

    ngAfterViewInit(): void {
        const step: HTMLElement = this.el.nativeElement;
        const wizard = step.closest('twc-wizard');
        const steps = step.closest('twc-wizard-steps');
        if (!steps || !wizard) {
            return;
        }

        setTimeout(() => {
            this.hideStepIcon(step, steps, wizard);
        }, 0);
    }

    ngOnDestroy(): void {
        if (this.styleEl?.parentNode) {
            this.styleEl.parentNode?.removeChild(this.styleEl);
        }
    }

    private hideStepIcon(step: HTMLElement, steps: Element, wizard: Element): void {
        const stepIndex = Array.from(steps.children).indexOf(step);
        if (!stepIndex) {
            return;
        }

        const wizardSwitch = wizard.querySelector('twc-wizard-switch');
        if (!wizardSwitch) {
            return;
        }

        const element: Element | null = wizardSwitch.children.item(stepIndex);
        if (element) {
            this.insertStyleInElement(element);
        }
    }

    private insertStyle(): void {
        const styleContent = `
          twc-wizard-switch-button.cwHideStepIcon::before {
            display: none;
          }
        `;

        this.styleEl = this.renderer.createElement('style');
        this.renderer.appendChild(this.styleEl, this.renderer.createText(styleContent));
        this.renderer.appendChild(document.head, this.styleEl);
    }

    private insertStyleInElement(element: Element): void {
        this.insertStyle();
        element.classList.add('cwHideStepIcon');
    }
}
